import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

import { ResponsiveFunnel } from '@nivo/funnel'
import { scaleLinear } from 'd3-scale'

import { percent } from './formatters'

const propTypes = {
  item: PropTypes.object,
  progressionType: PropTypes.string,
}

const Funnel = ({ item, progressionType }) => {
  const setColor = scaleLinear().domain([0, item.children.length]).range(['#338ccc', '#338ccc80'])

  const data = useMemo(() => item.children.map(({ total, value, completed, completedPC, abandonmentPC }) => ({
    id: value,
    value: progressionType === 'Impressions' ? total : completed,
    label: <span>
      <div>Slot: <b>{value + 1}</b></div>
      <div>Total Progression: <b>{total}</b></div>
      <div>Completed Progression: <b>{completed}</b></div>
      <div>Completed Percent: <b>{percent(completedPC)}</b></div>
      <div>Abandonment Percent: <b>{percent(abandonmentPC)}</b></div>
      <div>{progressionType === 'Impressions' ? <div>Completed: <b>{completed}</b></div> : <div>Impressions: <b>{total}</b></div>
      }</div>
      {progressionType}
    </span>,
  })), [progressionType, item])

  return <ResponsiveFunnel
    tooltip={({ part }) => <div className='z-[9999] twy-bg-base twy-text-base-accent p-2 rounded-sm shadow-md pointer-events-none' >
      {part?.data?.label || part?.label || `${part?.id ?? ''}`}
    </div>}
    data={data}
    height={41 * item.children.length}
    interpolation="smooth"
    shapeBlending={0.8}
    colors={slot => setColor(Number(slot.id))}
    enableLabel={false}
    borderWidth={0}
    beforeSeparatorLength={10}
    afterSeparatorLength={10}
    currentBorderWidth={10}
  />
}

Funnel.propTypes = propTypes

export default Funnel
